// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1mUGV","row":"styles_row__36i5v"};